import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

// Renders exactly the same markup and classes as scripts/layout.js so there is
// zero layout shift between the prerendered header and the hydrated one.
const LINKS: [string, string][] = [
  ['/', 'Hem'],
  ['/guide/', 'Guider'],
  ['/new', 'Skicka in'],
];

const BrandMark: React.FC = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M5 3h14l-1.6 6.1A5.6 5.6 0 0 1 13 13.2V19h3v2H8v-2h3v-5.8a5.6 5.6 0 0 1-4.4-4.1L5 3z"
      fill="#d9a534"
    />
    <path d="M6.1 5h11.8l-.5 2H6.6l-.5-2z" fill="#fbf7ef" />
  </svg>
);

const NavBar: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  const isActive = (href: string) => {
    if (href === '/new') return location.pathname === '/new' || location.pathname === '/new/';
    if (href === '/') return location.pathname === '/';
    return location.pathname === href;
  };

  return (
    <header className="sd-hdr" id="sd-hdr" data-open={open ? '1' : '0'}>
      <div className="sd-hdr-in">
        <Link className="sd-brand" to="/">
          <BrandMark />
          <span className="sd-brand-t">
            <span className="sd-brand-n">Snapsdags</span>
            <span className="sd-brand-s">Digitala snapsvisor</span>
          </span>
        </Link>
        <div className="sd-hdr-search">
          <button
            className="sd-search-btn"
            type="button"
            data-sd-search
            aria-label="Sök bland alla snapsvisor"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                d="M10 4a6 6 0 1 0 3.5 10.9l4.3 4.3 1.4-1.4-4.3-4.3A6 6 0 0 0 10 4zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"
                fill="currentColor"
              />
            </svg>
            <span className="sd-search-t">Sök visa</span>
            <span className="sd-search-kbd" aria-hidden="true">
              /
            </span>
          </button>
        </div>
        <button
          className="sd-burger"
          type="button"
          id="sd-burger"
          aria-label={open ? 'Stäng meny' : 'Visa meny'}
          aria-expanded={open}
          aria-controls="sd-nav"
          onClick={() => setOpen((v) => !v)}
        >
          <span />
        </button>
        <nav className="sd-nav" id="sd-nav" aria-label="Huvudmeny">
          <ul>
            {LINKS.map(([href, label]) =>
              href === '/new' || href === '/' ? (
                <li key={href}>
                  <Link to={href === '/' ? '/' : '/new/'} aria-current={isActive(href) ? 'page' : undefined}>
                    {label}
                  </Link>
                </li>
              ) : (
                <li key={href}>
                  <a href={href}>{label}</a>
                </li>
              )
            )}
          </ul>
          <a className="sd-cta" href="/sanghafte/">
            Skapa sånghäfte
          </a>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
